import { render, staticRenderFns } from "./SplashScreen.vue?vue&type=template&id=10ec5ef7"
import script from "./SplashScreen.vue?vue&type=script&lang=ts"
export * from "./SplashScreen.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports